import { Line } from 'vue-chartjs';
import _ from 'lodash';

export default {
    extends: Line,
    props: ['chartData'],
	data() {
		return {
			options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                 },
                 tooltips: {
                    // enabled: false
                 },
                scales: {
                  xAxes: [{
                    // display: false,
                    gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                    }
                  }],
                  yAxes: [{
                    // display: false,
                    gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                        drawBorder: true
                    },
                    ticks: {
                        beginAtZero: true
                    }
                  }]
                }
            }
		};
	},
    mounted () {
        this.renderChart(this.chartData, this.options);
    },
    watch: {
        chartData: {
            handler() {
              const clone = _.cloneDeep(this.chartData);
              this.renderChart(clone, this.options);
            },
            deep: true,
        }, 
    }
}